import { app } from '../../../../bootstrap/core';
import { ticketSummaryComponent } from './ticketSummary.component';

app.component('ticketSummary', ticketSummaryComponent);
